import HeadingInspector from './HeadingInspector'

export default HeadingInspector
